const campaignStatus = [
  {
    name: 'Registered',
    online: false
  },
  {
    name: 'RegisteredOnline',
    online: true
  }
]

export default campaignStatus
